import React from 'react'
import styled from 'styled-components'
import { TextBody } from '@ally/metronome-ui'
import { amountFormatter } from '../../utils/formatter'

type FormattedAmountStringProps = {
  value: number | string
  size?: 'sm' | 'md' | 'lg'
  tag?: 'span' | 'p'
  textAlign?: 'left' | 'right' | 'center'
  isHideErrorColor?: boolean
  isBold?: boolean
}
const StyledTextBody = styled(TextBody)<{
  isHideErrorColor?: boolean
  textAlign: string
  isNegative: boolean
  isBold: boolean
}>`
  color: ${({ isHideErrorColor, isNegative, theme: { colors } }): string => {
    return isNegative && !isHideErrorColor
      ? `${colors.error}`
      : `${colors['slate-5']}`
  }};

  white-space: nowrap;
  font-weight: ${({ isBold }): string => {
    return isBold ? `bold` : `normal`
  }};
  text-align: ${({ textAlign }): string => {
    return textAlign
  }};
`

// istanbul ignore file // TO DO METRONOME UPGRADE REMOVE IGNORE AFTER WE FIX TESTS FAILING

export const FormattedAmountString: React.FC<FormattedAmountStringProps> = ({
  value,
  size = 'sm',
  tag = 'span',
  textAlign = 'right',
  isHideErrorColor = false,
  isBold = false,
}) => {
  const numberValue = typeof value === 'string' ? parseFloat(value) : value
  const amount = amountFormatter.format(numberValue)
  const isNegative = amount[0] === '-'

  return isNegative ? (
    <StyledTextBody
      data-testid="negAmount"
      tag={tag}
      size={size}
      isHideErrorColor={isHideErrorColor}
      isNegative
      textAlign={textAlign}
      isBold={isBold}
    >
      &minus;{amount.replace('-', '')}
    </StyledTextBody>
  ) : (
    <StyledTextBody
      data-testid="posAmount"
      tag={tag}
      size={size}
      textAlign={textAlign}
      isNegative={false}
      isBold={isBold}
    >
      {amount}
    </StyledTextBody>
  )
}
